import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { auth } from '@/lib/api'
import { queryKeys } from '@/lib/queryKeys'

export function useMe() {
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: auth.me,
  })
}

export function useUpdateName() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (name: string) => auth.updateName(name),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.me })
    },
  })
}

export function useChangePassword() {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }) =>
      auth.changePassword(currentPassword, newPassword),
  })
}
